import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { StatBox, StatCardComponent } from '../../components/stat-card/stat-card.component';
import { ModuleStats, TopModule } from '../../models/dashboard.model';

const MOST_USED_CAP = 3;

@Component({
  selector: 'app-testmodule-stats-card',
  imports: [TranslatePipe, StatCardComponent],
  templateUrl: './testmodule-stats.component.html',
  styleUrl: './testmodule-stats.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestmoduleStatsCardComponent {
  module = input.required<ModuleStats>();

  protected readonly stats = computed<StatBox[]>(() => {
    const m = this.module();
    return [
      { labelKey: 'liveDashboard.qualitaet.module.gesamt', value: m.gesamt, colorVar: '--to-text-strong' },
      { labelKey: 'liveDashboard.qualitaet.module.aktiv', value: m.aktiv, colorVar: '--to-green-fg' },
      { labelKey: 'liveDashboard.qualitaet.module.ungenutzt', value: m.ungenutzt, colorVar: '--to-amber-deep' },
    ];
  });

  protected readonly topModules = computed<TopModule[]>(() => this.module().meistgenutzt.slice(0, MOST_USED_CAP));
}
